module.exports = __webpack_public_path__ + "media/images/home/icon-x-9e572177630d597acf7b5b3749def324.svg";